// src/components/HealthStatusIndicator/HealthStatusIndicator.js
import React from 'react';
import PropTypes from 'prop-types';
import './HealthStatusIndicator.css';
import { getHealthColor } from '../../pages/config/thresholds';

const HealthStatusIndicator = ({ 
  status, 
  size = 'medium', 
  position = 'top-right',
  showBorder = true,
  className = '' 
}) => {
  const color = getHealthColor(status);
  
  const sizeClasses = {
    small: 'health-indicator--small',
    medium: 'health-indicator--medium',
    large: 'health-indicator--large'
  };

  const positionClasses = {
    'top-right': 'health-indicator--top-right',
    'top-left': 'health-indicator--top-left',
    'bottom-right': 'health-indicator--bottom-right',
    'bottom-left': 'health-indicator--bottom-left',
    'center': 'health-indicator--center'
  };

  return (
    <div 
      className={`
        health-indicator 
        ${sizeClasses[size]} 
        ${positionClasses[position]}
        ${showBorder ? 'health-indicator--bordered' : ''}
        ${className}
      `}
      style={{ backgroundColor: color }}
      title={`Health Status: ${status}`}
      aria-label={`Health status indicator: ${status}`}
    />
  );
};

HealthStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['normal', 'warning', 'dangerous', 'neutral']).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  position: PropTypes.oneOf(['top-right', 'top-left', 'bottom-right', 'bottom-left', 'center']),
  showBorder: PropTypes.bool,
  className: PropTypes.string
};

export default HealthStatusIndicator;